module.exports = __webpack_public_path__ + "img/logo_login.2090f3fe.png";